import { TLanguage } from 'contexts/app-context/types'

import InterWebviewBridge, { IWbAppInfo, WbEnvironments } from '@interco/inter-webview-bridge'

const HABILITADO = 'HABILITADO'

const IS_DEV_ENV = process.env.NODE_ENV === 'development'

const IS_PRD = process.env.NODE_ENV === 'production'

type TInterBridgeInstance = ReturnType<typeof InterWebviewBridge.getInstance>

const createInterBridgeInstance = (): TInterBridgeInstance | null => {
  try {
    return InterWebviewBridge.getInstance()
  } catch (error: unknown) {
    if (IS_DEV_ENV) {
      global.console.debug('Failed to initialize inter bridge instance', error)
    }

    return null
  }
}

const INTER_BRIDGE = createInterBridgeInstance()

const getInterBridgeInstance = () => INTER_BRIDGE

const getBridgeEnvironment = () => {
  try {
    return INTER_BRIDGE?.getEnvironment?.() ?? WbEnvironments.BROWSER
  } catch (error: unknown) {
    if (IS_DEV_ENV) {
      global.console.debug('Failed to get inter bridge environment', error)
    }

    return WbEnvironments.BROWSER
  }
}

const IS_APP = getBridgeEnvironment() !== WbEnvironments.BROWSER

const IS_PRE_PROD = Boolean(window.location.origin.match(/preprod/gm))

const CLOUDFRONT_WEBVIEW_CONTENT_BASE_URL = process.env.REACT_APP_CLOUDFRONT_WEBVIEW_CONTENT

enum REACT_QUERY_KEYS {
  PREFERENCES = 'preferences',
  PURPOSES = 'purposes',
  REPORT_STATUS = 'report-status',
  REPORTS_IN_ANALYSIS = 'reports-in-analysis',
  REPORTS_HISTORY = 'reports-history',
  US_PREFERENCES = 'us-preferences',
  US_REPORT_STATUS = 'us-report-status',
  US_REPORT_STATUS_LIST = 'us-report-status-list',
  US_ALL_REPORTS = 'us-all-reports',
  US_PURPOSES = 'us-purposes',
  US_PENDING_REPORTS = 'us-pending-reports',
  US_REPORTS = 'us-reports',
  FAQ = 'faq',
  FAQ_ANSWER = 'faq-answer',
  TERMS = 'terms',
  ENTITIES = 'entities',
  SUPPORT = 'support',
  SUPPORT_RESPONSE = 'support-response',
  PRIVACY_POLICY_ACCEPTANCE_CONTENT = 'privacy-policy-acceptance-content',
  PRIVACY_POLICY_ACCEPTANCE_TERMS = 'privacy-policy-acceptance-terms',
}

enum Routes {
  ROOT = '/',
  ENTITY = '/entity',
  ENTITY_TRANSACTION = '/entity-transaction',
  HOME = '/home',
  NOTIFICATIONS_MANAGEMENT = '/notifications-management',
  YOUR_PERSONAL_DATA = '/your-personal-data',
  REPORTS_HISTORY = '/reports-history',
  REPORT_LOADER = '/report-loader',
  UNAVAILABLE_REPORT = '/unavailable-report',
  SUCCESS_REPORT_REQUESTED = '/success-report-requested',
  SUCCESS_EMAIL_SENT = '/success-email-sent',
  PDF_VIEWER = '/pdf-viewer',
  PRIVACY_POLICY = '/privacy-policy',
  PRIVACY_POLICY_ACCEPTANCE = '/privacy-policy-acceptance',
  PRIVACY_POLICY_ACCEPTANCE_PDF_VIEWER = '/privacy-policy-acceptance/pdf-viewer',
  PRIVACY_POLICY_ACCEPTANCE_SUCCESS = '/privacy-policy-acceptance/success',
  PRIVACY_POLICY_ACCEPTANCE_ERROR = '/privacy-policy-acceptance/error',
  FREQUENT_QUESTIONS = '/frequent-questions',
  UNAVAILABLE_SERVICE = '/unavailable-service',
  ERROR = '/error',
  MY_SERVICE_REQUESTS = '/my-service-requests',
  SERVICE_DETAILS = '/service-details',
  SERVICE_RESPONSE = '/service-response',
  NEW_SERVICE = '/new-service',
  SUCCES_SENDING_REPORT = '/success-sending-report',
  ERROR_SENDING_REPORT = '/error-sending-report',
  NEED_HELP = '/need-help',
  UNAVAILABLE_FEATURE = '/unavailable_feature',
  LEAVE_TO_APP = '/leave',
  UNKNOWN_ERROR = '/unknown_error',
}

const QUICK_LOAD_ROUTES: Record<string, Routes> = {
  NOTIFICATIONS_MANAGEMENT: Routes.NOTIFICATIONS_MANAGEMENT,
  YOUR_PERSONAL_DATA: Routes.YOUR_PERSONAL_DATA,
  PRIVACY_POLICY: Routes.PRIVACY_POLICY,
  FREQUENT_QUESTIONS: Routes.FREQUENT_QUESTIONS,
  MY_SERVICE_REQUESTS: Routes.MY_SERVICE_REQUESTS,
}

const BETA_ALLOWED_ACCOUNTS: string[] = [
  '53683315',
  '35716550',
  '57439818',
  '247063134',
  '521802938',
  '178414751',
  '8943591',
  '10000550',
  '5368331-5',
  '3571655-0',
  '5743981-8',
  '24706313-4',
  '52180293-8',
  '17841475-1',
  '1000055-0',
  '433543310',
  '43354331-0',
]

const LANGUAGE_OPTIONS = ['pt-BR', 'en-US', 'es-ES']

const LANGUAGE_DICTIONARY: Record<string, TLanguage> = {
  pt: 'pt-BR',
  PT: 'pt-BR',
  'pt-BR': 'pt-BR',
  en: 'en-US',
  EN: 'en-US',
  'en-US': 'en-US',
  es: 'es-ES',
  ES: 'es-ES',
  'es-ES': 'es-ES',
}

const SUCCESS_STATUS_CODE = [200, 201]

const MOCK_APP_INFO: IWbAppInfo = {
  organization: 'PJ',
  application: 'PJ',
  language: 'pt-BR',
  env: 'hmg',
  isDarkMode: false,
  deviceType: 'SMARTPHONE',
  dimensions: {
    height: 1647,
    width: 1080,
  },
  nomeTipo: 'nomeTipo',
  theme: 'theme',
  version: '1.0.0',
  appVersion: '1.0.0',
}

const HTTP_STATUS = {
  SUCCESS: '200',
  EMPTY: '204',
  CREATED: '201',
  NOT_FOUND: '404',
}

const SOLUTION_ID = 'CITRUS'

export {
  HTTP_STATUS,
  SOLUTION_ID,
  HABILITADO,
  IS_APP,
  IS_DEV_ENV,
  CLOUDFRONT_WEBVIEW_CONTENT_BASE_URL,
  REACT_QUERY_KEYS,
  SUCCESS_STATUS_CODE,
  MOCK_APP_INFO,
  Routes,
  QUICK_LOAD_ROUTES,
  IS_PRE_PROD,
  BETA_ALLOWED_ACCOUNTS,
  IS_PRD,
  LANGUAGE_OPTIONS,
  LANGUAGE_DICTIONARY,
  getBridgeEnvironment,
  getInterBridgeInstance,
}
